import { Typography } from '@material-ui/core'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { useState } from 'react'

import {
  MonitoringUpdateRatePlanLayer,
  MonitoringUpdateRatePlaneFieldsType
} from '../../types/monitoringUpdate'
import RatePlaneLayerRowMenu from './RatePlaneLayerRowMenu'
import RowBoxValuesRatePlaneMenu from './RowBoxValuesRatePlaneMenu'
import useStyles from './Styles/RatePlanLayer.Style'

interface RatePlaneLayerProps {
  dataRatePlane: MonitoringUpdateRatePlanLayer
  range: 'TWO_WEEKS' | 'MONTH'
  weekendIndexes: number[]
  showChannelsLayer: boolean | undefined
}

export default function RatePlaneLayer({
  range,
  dataRatePlane,
  weekendIndexes,
  showChannelsLayer
}: RatePlaneLayerProps) {
  const classes = useStyles()
  const [selectedRatePlaneRowMenu, setSelectedRatePlaneRowMenu] =
    useState<MonitoringUpdateRatePlaneFieldsType>('default')
  const mayItemMenuRatePlane: {
    value: MonitoringUpdateRatePlaneFieldsType
    label: string
  }[] = [
    { value: 'default', label: 'default' },
    { value: 'restrictions', label: 'restrictions' },
    { value: 'rates', label: 'rates' }
  ]
  const handleChangeSelectedInventoryFieldInRatePlan = (
    fieldType: MonitoringUpdateRatePlaneFieldsType
  ) => {
    setSelectedRatePlaneRowMenu(fieldType)
  }
  return (
    <div
      className={[
        showChannelsLayer ? classes.ratePlaneRowGrey : classes.ratePlaneRow,
        range === 'MONTH' ? classes.ratePlaneRowForMonth : ''
      ].join(' ')}>
      <div className={classes.rowName}>
        <Typography
          variant="h5"
          className={[
            showChannelsLayer
              ? classes.rowNameTitleMarginLeft
              : classes.rowNameTitle
          ].join(' ')}>
          {dataRatePlane.ratePlanName}
        </Typography>
      </div>
      <div className={classes.dayContainer}>
        <RatePlaneLayerRowMenu
          mayItemMenuRatePlane={mayItemMenuRatePlane}
          selectedRatePlaneRowMenu={selectedRatePlaneRowMenu}
          setSelectedRatePlaneRowMenu={setSelectedRatePlaneRowMenu}
          onChangeSelectedItem={(newMenuItem: string) =>
            handleChangeSelectedInventoryFieldInRatePlan(
              newMenuItem as MonitoringUpdateRatePlaneFieldsType
            )
          }
        />
        <ArrowRightIcon
          className={[
            classes.channelArrowRight,
            classes.channelArrowRightCollapsed
          ].join(' ')}
        />
      </div>
      <RowBoxValuesRatePlaneMenu
        selectedRatePlaneRowMenu={selectedRatePlaneRowMenu}
        dataRatePlane={dataRatePlane}
        range={range}
        weekendIndexes={weekendIndexes}
      />
    </div>
  )
}
